import { render, staticRenderFns } from "./addLoginDetailsModal.vue?vue&type=template&id=81d18c86&"
import script from "./addLoginDetailsModal.vue?vue&type=script&lang=js&"
export * from "./addLoginDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports